<template>
  <div class="footer-bottom">
    <div class="logo-box flex items-center justify-center">
      <div class="box-title mr-25">友情链接</div>
      <div v-for="(imgItem, index) in imgList" :key="index" class="logo-item mr-20" @click="openLink(imgItem)">
        <img :src="imgItem.imgUrl" class="logo-img" />
      </div>
    </div>
    <div class="footer-row flex items-center justify-center">
      <span class="mr-20">版权所有 Copyright © 2022</span>
      <span>潍坊市预制菜产业公共平台All Rights Reserved 鲁ICP备080000005号</span>
    </div>
  </div>
</template>

<script setup>
import { reactive } from 'vue'
import { useRouter, useRoute } from 'vue-router'
const router = useRouter()
const imgList = reactive([
  { imgUrl: require('@/assets/home/lname1.png'), linkUrl: 'http://www.weifang.gov.cn' },
  { imgUrl: require('@/assets/home/lname2.png'), linkUrl: 'https://www.freshhema.com' },
  { imgUrl: require('@/assets/home/lname3.png'), linkUrl: 'https://www.rongdaufun.com' },
  { imgUrl: require('@/assets/home/lname4.png'), linkUrl: 'https://www.1688.com/?spm=a260k.22464671.kyebv087.1.221a7a6egdQ9S4&theme=index' },
  { imgUrl: require('@/assets/home/lname5.png'), linkUrl: 'https://www.taobao.com' },
  { imgUrl: require('@/assets/home/lname6.png'), linkUrl: 'http://www.rt-mart.com.cn' }
])

function openLink(url) {
  if (url) {
    window.open(url.linkUrl)
  }
}
</script>
<style lang="scss" scoped>
.logo-box {
  width: 100%;
  min-width: 1200px;
  height: 104px;
  background: #4a4a4a;
  
  .box-title {
    font-size: 14px;
    font-family: AppleSystemUIFont;
    color: rgba($color: #ffffff, $alpha: 0.7);
  }

  .logo-item {
    width: 118px;
    height: 27px;
    cursor: pointer;
    &:last-child {
      margin-right: 0;
    }

    .logo-img {
      width: 100%;
      height: 100%;
    }
  }
}

.footer-row {
  width: 100%;
  min-width: 1200px;
  height: 36px;
  background: #171717;
  font-size: 12px;
  font-family: AppleSystemUIFont;
  color: #ffffff;
}
</style>
